import React from "react";
import { motion } from "framer-motion/dist/framer-motion";

import {
  divVariants,
  staticBounceVariants,
  slide_bounce_up_variants
} from "shared/components/animations";
import winnerSvg from "assets/images/gah/winner-over.svg";
import bannerLogo from "assets/images/gah/others-banner.png";

const GAHOver = ({ users, score, winnerCard }) => {
  const winner = users.find((user) => user.player_id === winnerCard.player_id);
  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="gah-over"
    >
      <motion.img
        variants={slide_bounce_up_variants}
        alt=""
        src={winnerSvg}
        className="top-image"
      />

      <motion.div
        variants={staticBounceVariants}
        className="top-others-banner over"
      >
        <img alt="" src={bannerLogo} />
        <h2 className="banner-text">{`POINTS: ${score}`}</h2>
      </motion.div>

      <motion.div variants={staticBounceVariants} className="winner-user">
        <img alt="" src={winner.profile_image} className="" />
        <span className="">{winner.display_name}</span>
      </motion.div>
    </motion.div>
  );
};

export default GAHOver;
